import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    this.gallerySection = this.closest('.shopify-section, dialog');
    this.gallerySection?.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    this.gallerySection?.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.gallerySection = null;
  }

  updateMediaGallery = (event) => {
    const html = event.detail?.data?.html;
    const nextGallery = html?.querySelector('product-media-gallery');
    if (!nextGallery) return;

    const newMediaGallery = nextGallery.querySelector('slider-component');
    const currentMediaGallery = this.querySelector('slider-component');
    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
      window.ShopifyXR?.setupXRElements();
    }

    // Keep the zoom gallery in sync with the selected colour as well.
    const nextZoom = nextGallery.querySelector('[data-pilaya-gallery-zoom]');
    const currentZoom = this.querySelector('[data-pilaya-gallery-zoom]');
    if (nextZoom && currentZoom && currentZoom.innerHTML !== nextZoom.innerHTML) {
      currentZoom.replaceWith(nextZoom);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}

